<template>
	<div class="pxrwwfgv-game-controls">
		<div class="pxrwwfgv-game-undo" :class="{'-disabled': _.isEmpty($store.getters['placedInterventions'])}" @click="undo">
			<wwf-icon name="back" :size="27" color="#fff" />
		</div>
		<div class="pxrwwfgv-game-display-result" @click="displayResult" :class="{'-disabled': !$store.getters['allSpotPlaced'] }">
			<wwf-icon name="triangle-right" :size="50" color="#fff" />
		</div>
		<div class="pxrwwfgv-toggle-fullscreen" @click="toggle">
			<wwf-icon name="compress-solid" :size="27" color="#fff" v-if="isFullscreen"/>
			<wwf-icon name="expand-solid" :size="27" color="#fff" v-else/>
		</div>

	</div>
	<HelpClickAnim left="871" top="-24" v-if="idle && store.getters['allSpotPlaced']" />

</template>

<script setup >
	//
	import _ from "lodash";
	import {watch, inject} from 'vue';
	import {useStore} from 'vuex';
	import { useIdle, useFullscreen, useScreenOrientation } from '@vueuse/core';


	import WwfIcon from "@/components/ui/WwfIcon.vue";
	import HelpClickAnim from '@/components/ui/HelpClickAnim.vue';

	const store = useStore();

	function undo(){
		store.dispatch('undoLastPlacedIntervention');		
	}

	function displayResult(){
		store.dispatch('setScreen', 'endvideo');
	}

	//fullscreen
	const viewportContainer = inject('viewportContainer');
	const {isFullscreen, toggle } = useFullscreen(viewportContainer);
	const {isSupported: soIsSupported, lockOrientation, unlockOrientation} = useScreenOrientation();

	if(soIsSupported.value){
		watch(isFullscreen, () => {
			if(isFullscreen.value){
				lockOrientation('landscape');
			}
			else {
				unlockOrientation();
			}
		});
	}

	//help
	const { idle } = useIdle(1 * 60 * 1000); //1 min 1 * 60 * 1000
</script>

<style scoped>
	.pxrwwfgv-game-controls {
		position: absolute;
		top: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		gap: 15px;
	}
	.pxrwwfgv-game-undo,
	.pxrwwfgv-toggle-fullscreen {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 50px;
		height: 50px;
		background-color: var(--color-light-green);
		border-radius: 100%;
		cursor: pointer;
	}
	.pxrwwfgv-game-display-result {
		display: flex;
		justify-content: center;
		align-items: center;
		width: 83px;
		height: 83px;
		background-color: var(--color-light-green);
		border-radius: 100%;
		cursor: pointer;
	}
	.pxrwwfgv-game-display-result .pxrwwfgv-icon {
		margin-right: -13px;
	}

	.pxrwwfgv-game-undo.-disabled,
	.pxrwwfgv-game-display-result.-disabled {
		filter: contrast(20%) brightness(1.5);
		pointer-events: none;
	}
</style>